import { matrixMinMaxZ } from 'ml-spectra-processing';
/**
 * Those functions should disappear if add2D becomes accessible in jcampconvert
 * @param spectra
 * @returns {{z: Array, minX: *, maxX: *, minY: *, maxY: *, minZ: *, maxZ: *, noise: number}}
 */

export default function convertTo3DZ(spectra) {
  let ySize = spectra.length;
  let xSize = spectra[0].data.re.length;
  let z = new Array(ySize);

  for (let i = 0; i < ySize; i++) {
    z[i] = new Float64Array(spectra[i].data.re);
  }
  const firstX = spectra[0].data.x[0];
  const lastX = spectra[0].data.x[xSize - 1];
  const firstY = spectra[0].pageValue;
  const lastY = spectra[ySize - 1].pageValue;

  // Because the min / max value are the only information about the matrix if we invert
  // min and max we need to invert the array
  if (firstX > lastX) {
    for (let spectrum of z) {
      spectrum.reverse();
    }
  }
  if (firstY > lastY) {
    z.reverse();
  }

  let minMaxX =
    firstX < lastX
      ? { minX: firstX, maxX: lastX }
      : { minX: lastX, maxX: firstX };
  let minMaxY =
    firstY < lastY
      ? { minY: firstY, maxY: lastY }
      : { minY: lastY, maxY: firstY };

  const { min: minZ, max: maxZ } = matrixMinMaxZ(z);

  return {
    z,
    minZ,
    maxZ,
    ...minMaxX,
    ...minMaxY,
  };
}
